export const categoriesSortBySlug = [
  'subscription-billing',
  'login-account-setup',
  'forms-categories-and-search',
  'forms-export',
  'api-integrations',
  'data-privacy',
  'other',
];
